export enum UnitUsd {
  usd = 'usd',
  unit = 'unit',
}
